/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import {
  AppGitCreateInput,
  AppGitCreateInput$Outbound,
  AppGitCreateInput$outboundSchema,
} from "./appgitcreateinput.js";
import { AppOCI, AppOCI$Outbound, AppOCI$outboundSchema } from "./appoci.js";

export type V1AppsCreateAppRequestBody2 = {
  /**
   * Identifies a resource by either its unique ID or its slug.
   *
   * @remarks
   * Accepts a prefixed ID (such as 'proj_' or 'app_') or a slug.
   */
  project: string;
  /**
   * Human-readable name for this app.
   */
  name: string;
  /**
   * Identifies a resource by either its unique ID or its slug.
   *
   * @remarks
   * Accepts a prefixed ID (such as 'proj_' or 'app_') or a slug.
   */
  slug: string;
  /**
   * Configure Git as the app source. Provide `repository` to connect it during
   *
   * @remarks
   * creation, or use an empty object to connect a repository later.
   */
  git?: AppGitCreateInput | undefined;
  /**
   * An app's OCI image source.
   */
  oci: AppOCI;
};

export type V1AppsCreateAppRequestBody1 = {
  /**
   * Identifies a resource by either its unique ID or its slug.
   *
   * @remarks
   * Accepts a prefixed ID (such as 'proj_' or 'app_') or a slug.
   */
  project: string;
  /**
   * Human-readable name for this app.
   */
  name: string;
  /**
   * Identifies a resource by either its unique ID or its slug.
   *
   * @remarks
   * Accepts a prefixed ID (such as 'proj_' or 'app_') or a slug.
   */
  slug: string;
  /**
   * Configure Git as the app source. Provide `repository` to connect it during
   *
   * @remarks
   * creation, or use an empty object to connect a repository later.
   */
  git: AppGitCreateInput;
  /**
   * An app's OCI image source.
   */
  oci?: AppOCI | undefined;
};

/**
 * Create an app with exactly one source: `git` or `oci`. Requests that omit a
 *
 * @remarks
 * source or provide both sources are rejected.
 */
export type V1AppsCreateAppRequestBodyUnion =
  | V1AppsCreateAppRequestBody1
  | V1AppsCreateAppRequestBody2;

/** @internal */
export type V1AppsCreateAppRequestBody2$Outbound = {
  project: string;
  name: string;
  slug: string;
  git?: AppGitCreateInput$Outbound | undefined;
  oci: AppOCI$Outbound;
};

/** @internal */
export const V1AppsCreateAppRequestBody2$outboundSchema: z.ZodType<
  V1AppsCreateAppRequestBody2$Outbound,
  z.ZodTypeDef,
  V1AppsCreateAppRequestBody2
> = z.object({
  project: z.string(),
  name: z.string(),
  slug: z.string(),
  git: AppGitCreateInput$outboundSchema.optional(),
  oci: AppOCI$outboundSchema,
});

export function v1AppsCreateAppRequestBody2ToJSON(
  v1AppsCreateAppRequestBody2: V1AppsCreateAppRequestBody2,
): string {
  return JSON.stringify(
    V1AppsCreateAppRequestBody2$outboundSchema.parse(
      v1AppsCreateAppRequestBody2,
    ),
  );
}

/** @internal */
export type V1AppsCreateAppRequestBody1$Outbound = {
  project: string;
  name: string;
  slug: string;
  git: AppGitCreateInput$Outbound;
  oci?: AppOCI$Outbound | undefined;
};

/** @internal */
export const V1AppsCreateAppRequestBody1$outboundSchema: z.ZodType<
  V1AppsCreateAppRequestBody1$Outbound,
  z.ZodTypeDef,
  V1AppsCreateAppRequestBody1
> = z.object({
  project: z.string(),
  name: z.string(),
  slug: z.string(),
  git: AppGitCreateInput$outboundSchema,
  oci: AppOCI$outboundSchema.optional(),
});

export function v1AppsCreateAppRequestBody1ToJSON(
  v1AppsCreateAppRequestBody1: V1AppsCreateAppRequestBody1,
): string {
  return JSON.stringify(
    V1AppsCreateAppRequestBody1$outboundSchema.parse(
      v1AppsCreateAppRequestBody1,
    ),
  );
}

/** @internal */
export type V1AppsCreateAppRequestBodyUnion$Outbound =
  | V1AppsCreateAppRequestBody1$Outbound
  | V1AppsCreateAppRequestBody2$Outbound;

/** @internal */
export const V1AppsCreateAppRequestBodyUnion$outboundSchema: z.ZodType<
  V1AppsCreateAppRequestBodyUnion$Outbound,
  z.ZodTypeDef,
  V1AppsCreateAppRequestBodyUnion
> = z.union([
  z.lazy(() => V1AppsCreateAppRequestBody1$outboundSchema),
  z.lazy(() => V1AppsCreateAppRequestBody2$outboundSchema),
]);

export function v1AppsCreateAppRequestBodyUnionToJSON(
  v1AppsCreateAppRequestBodyUnion: V1AppsCreateAppRequestBodyUnion,
): string {
  return JSON.stringify(
    V1AppsCreateAppRequestBodyUnion$outboundSchema.parse(
      v1AppsCreateAppRequestBodyUnion,
    ),
  );
}
